import { getApiBaseUrl } from '../../utils/media';
import {
  fallbackDiabetesBlogs,
  getRelatedFallbackBlogs,
} from './fallbackDiabetesBlogs';

const API_BASE_URL = getApiBaseUrl();

export const blogAPI = {
  getBlogs: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/blog-page`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();
      return Array.isArray(payload.data && payload.data.blogs) ? payload.data.blogs : fallbackDiabetesBlogs;
    } catch (error) {
      return fallbackDiabetesBlogs;
    }
  },

  getBlogBySlug: async (slug) => {
    try {
      const response = await fetch(`${API_BASE_URL}/blogs/public/${slug}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();
      return payload.data || null;
    } catch (error) {
      return fallbackDiabetesBlogs.find((blog) => blog.slug === slug) || null;
    }
  },

  getRelatedBlogs: async (currentSlug) => {
    try {
      const blogs = await blogAPI.getBlogs();
      return blogs.filter((blog) => blog.slug !== currentSlug).slice(0, 3);
    } catch (error) {
      return getRelatedFallbackBlogs(currentSlug, 3);
    }
  },
};

export const utils = {
  generateExcerpt: (htmlContent, length = 150) => {
    if (!htmlContent) return 'No content available';

    const plainText = htmlContent.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();

    return plainText.length > length
      ? `${plainText.substring(0, length).trim()}...`
      : plainText;
  },

  calculateReadTime: (htmlContent) => {
    if (!htmlContent) return '3 min';

    const plainText = htmlContent.replace(/<[^>]*>/g, '').trim();
    const wordCount = plainText.split(/\s+/).length;
    const readTimeMinutes = Math.max(1, Math.ceil(wordCount / 200));

    return `${readTimeMinutes} min`;
  },

  formatDate: (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  },
};
